import { meetsPermission } from '../permissionLevel.js';

export type KnowledgeBaseAccess = {
  isKbAdmin: boolean;
  canWrite: boolean;
  canRead: boolean;
};

type KnowledgeBaseAccessSource = {
  isOwner: boolean | undefined;
  email: string | undefined;
  aiHubLevel: string | undefined;
};

const MINT_EMAIL = /@mint\./i;

export const getKnowledgeBaseAccess = ({
  isOwner,
  email,
  aiHubLevel,
}: KnowledgeBaseAccessSource): KnowledgeBaseAccess => {
  const isKbAdmin = Boolean(isOwner) && MINT_EMAIL.test(email ?? '');
  const canWrite = isKbAdmin || meetsPermission(aiHubLevel, 'modify');

  return {
    isKbAdmin,
    canWrite,
    canRead: canWrite || meetsPermission(aiHubLevel, 'view'),
  };
};

type ManagedFolder = {
  isBucket?: boolean;
  isSystem?: boolean;
};

export const canManageFolder = (
  { isBucket, isSystem }: ManagedFolder,
  { isKbAdmin, canWrite }: KnowledgeBaseAccess,
): boolean => {
  if (isSystem) return false;

  return isBucket ? isKbAdmin : canWrite;
};

type SharedFolder = ManagedFolder & {
  isPrivate?: boolean;
};

export const canShareFolder = (
  { isBucket, isSystem, isPrivate }: SharedFolder,
  { isKbAdmin }: KnowledgeBaseAccess,
): boolean => {
  return Boolean(isBucket) && !isSystem && !isPrivate && isKbAdmin;
};

export type RowAction = 'ask' | 'move' | 'download' | 'delete';

export const getRowActions = (
  { isKbAdmin, canWrite, canRead }: KnowledgeBaseAccess,
  isUploader: boolean,
): RowAction[] => {
  const actions: RowAction[] = [];

  if (canRead) actions.push('ask');
  if (canWrite) actions.push('download', 'move');
  if (isKbAdmin || (canWrite && isUploader)) actions.push('delete');

  return actions;
};
